import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canViewPath } from '../constants/permissions';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, isReportingManager } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0052FF]"></div>
      </div>
    );
  }

  if (!user || user === false) {
    return <Navigate to="/login" replace />;
  }

  const userRoles = Array.isArray(user.roles) ? user.roles : [user.role];
  const isCompanyAdmin = user.role === 'COMPANY_ADMIN' || user.role === 'company_admin' || userRoles.includes('COMPANY_ADMIN') || userRoles.includes('company_admin');

  if (allowedRoles) {
    const hasRoleMatch = allowedRoles.includes(user.role) ||
      userRoles.some(r => allowedRoles.includes(r)) ||
      (allowedRoles.includes('tenant_admin') && isCompanyAdmin) ||
      (allowedRoles.includes('COMPANY_ADMIN') && userRoles.includes('tenant_admin'));

    if (!hasRoleMatch) {
      if (allowedRoles.includes('is_reporting_manager') && isReportingManager) {
        // pass through
      } else {
        // Check if user has custom role or permissions matching the path
        const isCustomRole = (user.role || '').startsWith('custom:');
        const hasPerms = user && Array.isArray(user.permissions) && user.permissions.length > 0;
        
        if ((isCustomRole || hasPerms || isCompanyAdmin) && canViewPath(user, location.pathname)) {
          // Custom role / Company Admin with valid permissions, allow through
        } else {
          return <Navigate to="/dashboard" replace />;
        }
      }
    }
  }

  // First-login wizard: tenant_admin or COMPANY_ADMIN on an un-setup tenant → redirect to /setup
  if (
    (user.role === 'tenant_admin' || isCompanyAdmin) &&
    user.setup_completed === false &&
    location.pathname !== '/setup' &&
    location.pathname !== '/profile'
  ) {
    return <Navigate to="/setup" replace />;
  }

  return children;
};

export default ProtectedRoute;
